<template>
  <div class="amgm-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex> \$2\$ </div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
             <label>平均值 AM (半径)</label>
             <span class="val">{{ amVal.toFixed(2) }}</span>
          </div>
          <div class="hud-item orange">
             <label>几何均值 GM (垂线)</label>
             <span class="val">{{ gmVal.toFixed(2) }}</span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 400 240" preserveAspectRatio="xMidYMid meet">
          <g transform="translate(50, 200)">
             <!-- 半圆 -->
             <path :d="`M 0,0 A ${radius},${radius} 0 0,1 ${radius*2},0`" fill="rgba(6, 182, 212, 0.1)" stroke="#334155" stroke-dasharray="4,2" />
             <line x1="0" y1="0" :x2="radius*2" y2="0" stroke="#1e293b" stroke-width="2" />
             
             <!-- a, b 分界 -->
             <line x1="0" y1="0" :x2="a_disp" y2="0" stroke="#f43f5e" stroke-width="4" />
             <text :x="a_disp/2" y="15" text-anchor="middle" fill="#f43f5e" font-size="10" font-weight="900">a</text>
             <line :x1="a_disp" y1="0" :x2="radius*2" y2="0" stroke="#0ea5e9" stroke-width="4" />
             <text :x="a_disp + (radius*2-a_disp)/2" y="15" text-anchor="middle" fill="#0ea5e9" font-size="10" font-weight="900">b</text>

             <!-- AM 线 (半径) -->
             <line :x1="radius" y1="0" :x2="radius" :y2="-radius" stroke="#fbbf24" stroke-width="3" stroke-dasharray="2,1" />
             <text :x="radius+5" :y="-radius/2" fill="#fbbf24" font-size="10" font-weight="900">AM = (a+b)/2</text>
             
             <!-- GM 线 (公垂线) -->
             <line :x1="a_disp" y1="0" :x2="a_disp" :y2="-gm_h" stroke="#10b981" stroke-width="3" />
             <text :x="a_disp-5" :y="-gm_h/2" text-anchor="end" fill="#10b981" font-size="10" font-weight="900">GM = √(ab)</text>
          </g>
        </svg>
        <div class="physics-caption">规律：几何平均值(高度) 永不大于 算术平均值(半径)</div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="flex-row gap-6">
              <div class="flex-1">
                 <label class="s-label">参数 a (调节红色段)</label>
                 <el-slider v-model="a" :min="10" :max="90" size="small"></el-slider>
              </div>
              <div class="flex-1">
                 <label class="s-label">参数 b (调节蓝色段)</label>
                 <el-slider v-model="b" :min="10" :max="90" size="small"></el-slider>
              </div>
           </div>
        </div>
        <div class="discovery-card-discovery" v-latex>
           <i class="el-icon-zoom-in"></i>
           <p><strong>数学之美：</strong>在同一个半圆中，圆内弦的高度 $\sqrt{ab}$ 永远不可能超过半径 $(a+b)/2$。<strong v-latex>只有当 $a=b$ 时</strong>，垂线恰好变成半径，两者才相等。这不仅是公式，更是自然的几何限制。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'AMGM_InequalityViz',
  data() { return { a: 30, b: 70 } },
  computed: {
    amVal() { return (this.a + this.b) / 2; },
    gmVal() { return Math.sqrt(this.a * this.b); },
    radius() { return (this.a + this.b) * 1.5; },
    a_disp() { return this.a * 3; },
    gm_h() { return Math.sqrt(this.a_disp * (this.radius*2 - this.a_disp)); }
  }
}
</script>

<style scoped lang="scss">
@import "./InequalityStyle.scss";
.amgm-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
</style>
